module.exports = "pegasus_template/assets/themelp1/basic/105.png";